<div class="ng-filter-help">
    <div class="ng-filter-img">
        <img src="/img/search/filter.png">
    </div>
    <div class="ng-filter-content">
        <p class="ng-filter-header">{{ messages.useFilters }}</p>
        <p>- {{ messages.easierToFind }}</p>
    </div>
    <div class="ng-arrow">
        <img src="/img/search/filter-arrow.png">
    </div>
</div>
